import KeenSlider from 'keen-slider'

const keenslider = () => {

    const sliderElements = document.querySelectorAll(".myKeenSlider");
    let interval = 0;

    // autoplay
    function autoplay(run) {
        clearInterval(interval);
        interval = setInterval(() => {
            if (run && slider) {
                slider.next();
            }
        }, 2000);
    }

    // Navigation (dots e frecce)
    function navigation(slider) {
        let wrapper, dots

        function markup(remove) {
            wrapperMarkup(remove)
            dotMarkup(remove)
        }

        function removeElement(elment) {
            elment.parentNode.removeChild(elment)
        }
        function createDiv(className) {
            let div = document.createElement("div")
            let classNames = className.split(" ")
            classNames.forEach((name) => div.classList.add(name))
            return div
        }

        function wrapperMarkup(remove) {
            if (remove) {
                let parent = wrapper.parentNode
                while (wrapper.firstChild)
                    parent.insertBefore(wrapper.firstChild, wrapper)
                removeElement(wrapper)
                return
            }
            wrapper = createDiv("navigation-wrapper")
            slider.container.parentNode.appendChild(wrapper)
            wrapper.appendChild(slider.container)
        }

        function dotMarkup(remove) {
            if (remove) {
                removeElement(dots)
                return
            }
            dots = createDiv("dots")
            slider.track.details.slides.forEach((_e, idx) => {
                let dot = createDiv("dot")
                dot.addEventListener("click", () => slider.moveToIdx(idx))
                dots.appendChild(dot)
            })
            wrapper.appendChild(dots)
        }

        function updateClasses() {
            let slide = slider.track.details.rel
            Array.from(dots.children).forEach(function (dot, idx) {
                idx === slide
                    ? dot.classList.add("dot--active")
                    : dot.classList.remove("dot--active")
            })
        }

        slider.on("created", () => {
            markup()
            updateClasses()
        })
        slider.on("optionsChanged", () => {
            console.log(2)
            markup(true)
            markup()
            updateClasses()
        })
        slider.on("slideChanged", () => {
            updateClasses()
        })
        slider.on("destroyed", () => {
            markup(true)
        })
    }

    //console.log(sliderElements);

    if (sliderElements.length > 0) {
        sliderElements.forEach(slider => {
            new KeenSlider(
                slider,
                {
                    loop: false,
                    renderMode: 'performance',
                    created: () => {
                        //console.log('created')
                    },
                    dragStart: () => {
                        //autoplay(false);
                    },
                    dragEnd: () => {
                        //autoplay(true);
                    },
                },
                [navigation]
            )
        })
    }

    /* sliderElements.forEach(element => {
        element.addEventListener("mouseover", () => {
            autoplay(false);
        });
        element.addEventListener("mouseout", () => {
            autoplay(true);
        });
    }); */

    //autoplay(true);
}

export { keenslider as default };